import React from "react";
import { Routes, Route } from "react-router-dom";
import Page from "../pages/Page";

function PrivateRoutes() {
  return (
    <Routes>
      <Route path="" element={<Page />} />
      {/* <Route path="" element={<ProfileCard />} /> */}
    </Routes>
  );
}

export default PrivateRoutes;
